import React from "react";
import Chip from "@mui/material/Chip";

export default function CommonChip({ labelName, color, sx }) {
  return <Chip sx={sx} label={labelName} color={color} />;
}
